import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  approveClockFailure,
  approveClockSuccess,
  fetchDiscrepancyFailure,
  fetchDiscrepancySuccess,
} from "./actions";
import { APPROVE_CLOCK, FETCH_DISCREPANCY } from "./constants";

export function* fetchDiscrepancySaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { filter } = payload;
  let query = filter ? QueryString.stringify(filter) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/discrepancy-confirm-list?${query}`
    );
    yield put(fetchDiscrepancySuccess(data));
    typeof onSuccess === "function" && onSuccess();
  } catch (e) {
    yield put(fetchDiscrepancyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}
export function* approveClockSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/discrepancy-approved`,
      payload
    );
    yield put(approveClockSuccess());
    yield put(successAlert("Discrepancy updated successfully!"));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(approveClockFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}
export function* fetchDiscrepancyFlow() {
  yield takeEvery(FETCH_DISCREPANCY, fetchDiscrepancySaga);
}
export function* approveClockFlow() {
  yield takeEvery(APPROVE_CLOCK, approveClockSaga);
}

export default function* DiscrepancySaga() {
  yield all([fetchDiscrepancyFlow(), approveClockFlow()]);
}
